import Swiper from "swiper/bundle";

document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".mySwiper", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
  new Swiper(".mySwiperProducts", {
      slidesPerView: 1,
      spaceBetween: 24,
      navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
      },
      pagination: {
          el: ".swiper-pagination",
          clickable: true,
      },
      loop: true,
    breakpoints: {
        1400:{slidesPerView: 4},
          961: { slidesPerView: 3 },
          740: { slidesPerView: 2 },
      },
  });
});
